module.exports = __webpack_public_path__ + "img/stop.cb3af30d.png";